export default __webpack_public_path__ + "static/media/grama.6e67c5b0.jpg";